import { createTheme, ThemeOptions } from "@mui/material/styles";
import { breakpoints } from "./breakpoints";
import typography from "./typography";
import palette from "./palette";

const theme: ThemeOptions = createTheme({
  palette: palette,
  typography: typography,
  breakpoints: breakpoints,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '8px'
        }
      },
    },

    MuiSelect: {
      defaultProps: {
        color: "primary",
      },
      styleOverrides: {
        select: {
          fontSize: "14px",
          height: "20px",
        },
      },
    },

    MuiCircularProgress: {
      defaultProps: {
        thickness: 4,
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '8px'
        },
      }
    },

    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: '10px',
          lineHeight: '12px',
          fontFamily: 'WorkSans-Regular'
        }
      }
    }

  },
});

export default theme;
